import { createListenerMiddleware } from '@reduxjs/toolkit';
import constant from '~/constant';
import createListenerEffect from '~/createListenerEffect';
import { setUserAgentData } from '~/redux/slice';

export const effect = createListenerEffect(
  'common/setUserAgentData<Listener>',
  async (action, { dispatch, trigger, unsubscribe }) => {
    unsubscribe();
    if (typeof navigator.userAgentData !== 'undefined') {
      await dispatch(setUserAgentData({ data: navigator.userAgentData.toJSON(), trigger }));
    }
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  matcher: constant(true),
  effect,
});

export default middleware;
